import React from "react";
import { MagnifyingGlass, Target, GoogleLogo, ChartLineUp, Users, EnvelopeSimple } from "@phosphor-icons/react";

const BG = "https://images.unsplash.com/photo-1498262257252-c282316270bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGdlb21ldHJpYyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODcxNDI1ODl8MA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/app";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FAFAFA]">
      {/* Left */}
      <div className="flex flex-col justify-between p-8 lg:p-16">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-md bg-zinc-900 flex items-center justify-center">
            <Target size={18} weight="bold" color="#fff" />
          </div>
          <span className="font-head font-bold text-lg tracking-tight">HireReach</span>
        </div>

        <div className="max-w-md">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 mb-5">
            Hiring Decision Maker Finder
          </p>
          <h1 className="font-head text-4xl sm:text-5xl font-extrabold tracking-tighter leading-[1.05] mb-5">
            Find the people who can hire you.
          </h1>
          <p className="text-base text-zinc-600 mb-10 leading-relaxed">
            Enter a company and target role. We'll identify the most relevant decision-makers,
            department leaders and recruiters — ranked by hiring relevance.
          </p>

          <button
            data-testid="google-login-button"
            onClick={handleLogin}
            className="inline-flex items-center gap-3 bg-zinc-900 text-white px-6 h-12 rounded-lg font-medium text-sm hover:bg-zinc-800 transition-colors active:scale-[0.98]"
          >
            <GoogleLogo size={20} weight="bold" />
            Continue with Google
          </button>

          <div className="mt-12 grid grid-cols-3 gap-4 max-w-sm">
            {[
              { icon: Users, label: "Ranked contacts" },
              { icon: EnvelopeSimple, label: "Verified emails" },
              { icon: ChartLineUp, label: "Relevance score" },
            ].map((f, i) => (
              <div key={i} className="flex flex-col gap-2">
                <f.icon size={20} className="text-zinc-900" />
                <span className="text-xs text-zinc-500">{f.label}</span>
              </div>
            ))}
          </div>
        </div>

        <p className="text-xs text-zinc-400">Demo data included. Connect Hunter or Apollo for live results.</p>
      </div>

      {/* Right */}
      <div className="hidden lg:block relative overflow-hidden">
        <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-zinc-900/40" />
        <div className="absolute inset-0 grain" />
        <div className="absolute bottom-12 left-12 right-12">
          <div className="backdrop-blur-xl bg-white/90 border border-white/40 rounded-xl p-6 shadow-2xl">
            <div className="flex items-center gap-3 mb-3">
              <MagnifyingGlass size={18} className="text-zinc-900" />
              <span className="font-head font-semibold tracking-tight">Sarah Williams · Head of Growth</span>
              <span className="ml-auto text-xs font-bold text-emerald-600">94/100</span>
            </div>
            <p className="text-sm text-zinc-600">
              "Directly aligned with the Performance Marketing function and likely the hiring manager."
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
